<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
        <Detail ref="detailRef" v-show="showDetail" />
        <a-row :gutter="24">
         <a-col :span="24">
           <a-form-model-item :label="$t('审批意见')" prop="audit">
             <a-radio-group v-model="model.audit">
               <a-radio :value="1">{{ $t('通过') }}</a-radio>
               <a-radio :value="0">{{ $t('驳回') }}</a-radio>
             </a-radio-group>
           </a-form-model-item>
         </a-col>
         <a-col :span="24">
           <a-form-model-item :label="$t('备注说明')" prop="remark">
             <a-textarea v-model="model.remark" :placeholder="$t('请输入备注信息')" :rows="4" />
           </a-form-model-item>
         </a-col>
        </a-row>
        <!-- <a-col :span="24" v-if="model.audit == 1">
          <a-form-model-item label="下一节点操作人" prop="candidateUsers">
            <a-select mode="multiple" placeholder="请选择操作人" v-model="model.candidateUsers">
              <a-select-option :value="item.userName" v-for="item in candidateUsersList">{{item.userRealname}}</a-select-option>
            </a-select> 
          </a-form-model-item>
        </a-col> -->
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction,postAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import { ACCESS_TOKEN } from "@/store/mutation-types"
  import Vue from 'vue'
  import JUpload from '@/components/jeecg/JUpload'
  import JImageUpload from '@/components/jeecg/JImageUpload.vue'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import Detail from '../detail'

  export default {
    name: 'ConstructionDetailForm',
    components: {
      JUpload,
      DetailList,
      DetailListItem,
      JImageUpload,
      Detail
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
         },
        confirmLoading: false,
        remarkRequired: true,
        url: {
          pass: "/jeecg-engineering/flowable/task/completeByDateId",
          reject: "/jeecg-engineering/flowable/task/taskRejectByDataId",
          // userList: "/jeecg-engineering/flowable/definition/userList",
          userList: "/jeecg-engineering/ticket/ticketsUser/list",
          getApprovalDetail: "/jeecg-engineering/engineering/installationDetail/getApprovalDetail",
          editApproverName: "/jeecg-engineering/ticket/tickets/editApproverName",
          queryById: "/jeecg-engineering/ticket/tickets/queryById",
        },
        tokenHeader: {'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)},
        fileList1: [],
        fileList2: [],
        candidateUsersList: [],
        bool: false,
        kcInfo: {},
        ysInfo: {},
        showDetail: false,
        defaultkey: ['4']
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      validatorRules () {
        return {
          audit:{ required: true,message: this.$t('请选择审批意见'), trigger: 'change' },
          remark:{ required: this.remarkRequired,message: this.$t('请输入备注'), trigger: 'input' },
          candidateUsers:{ required: true,message: this.$t('请选择下一节点操作人'), trigger: 'change' }
        }
      },
    },
    watch:{
      'model.audit':{
        handler(val){
          if(val == 1){
            this.remarkRequired = false;
          }else{
            this.remarkRequired = true;
          }
        }
      }
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      getUserList(){
        getAction(this.url.userList,{pageSize:999}).then(res=>{
          if(res.success){
            this.candidateUsersList = res.result.records;
          }
        })
      },
      add () {
        this.edit(this.modelDefault);
      },
      edit (record,bool) {
        debugger
        let that = this;
        this.bool = bool;
        // 清除表单验证
        this.$nextTick(()=>{
          this.$refs.form.clearValidate();
        })

        if(record.id){
          // 获取详情信息
          getAction(this.url.queryById,{id:record.id}).then(res=>{
            if(res.success){
              that.ticketsData = { ...res.result }
              // 报装 勘察信息
              that.model = { 
                ...res.result.installationDetail,
                // dataId:  res.result.id,
                // installationId:  res.result.ticketsForeignId,
                // ticketsId:  res.result.id,
               }
               // 确保子组件已挂载
              that.$nextTick(() => {
                if(that.$refs.detailRef) {
                  that.$refs.detailRef.init(that.ticketsData, bool);
                  that.showDetail = true;
                } else {
                  console.error('子组件引用不存在');
                }
              });
            }
          })
        }

        this.visible = true;
        this.getUserList();
 
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            if(that.model.audit == 1){
              httpurl+=this.url.pass;
            }else{
              httpurl+=this.url.reject;
            }
            let params = {
              // candidateUsers: that.model.candidateUsers,
              dataId: that.ticketsData.id,
              values: {
                dataId: that.ticketsData.id,
              },
              comment: that.model.remark?that.model.remark:''
            }
            postAction(httpurl,params).then((res)=>{
              if(res.success){
                that.$message.success(this.$t('操作成功'));
                that.$emit('ok');
                // // 更新节点处理人
                // postAction(that.url.editApproverName,{
                //   id: that.model.id,
                //   ticketsId: that.model.ticketsId,
                //   ticketsType: that.model.ticketsType,
                //   approverName: that.model.candidateUsers && that.model.candidateUsers.join(','),
                // }).then(val=>{
                //   if(res.success){
                //     // that.$message.success('更新节点处理人成功');
                //       that.$message.success('操作成功');
                //       that.$emit('ok');
                //   }
                // });
              }else{
                that.$message.warning(this.$t('操作失败'));
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })
      },
    }
  }
</script>
<style lang="less" scoped>
  .lab-title{
    font-weight: bold;
    color: #000;
 }
  .ant-collapse{
    background-color: #fff;
  }
  /deep/.detail-list .content {
    line-height: normal;
  }
</style>